import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './Tag.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "tag",
      attrs: { draggable: "true" },
      on: {
        dragstart: _vm.onDragStart,
        dragend: function($event) {
          $event.preventDefault();
          return _vm.onDragEnd($event)
        },
        drag: _vm.onDrag
      }
    },
    [
      _vm._t("default", [
        _c("div", { staticClass: "label" }, [
          _vm._v("\n            " + _vm._s(_vm.tag.label) + "\n        ")
        ])
      ]),
      _vm._v(" "),
      _vm.shouldShowRemoveButton
        ? _c(
            "div",
            {
              ref: "remove",
              staticClass: "remove-tag",
              attrs: { "data-cy": "remove-tag" },
              on: {
                mousedown: function($event) {
                  $event.preventDefault();
                  $event.stopPropagation();
                },
                click: function($event) {
                  $event.stopPropagation();
                  return _vm.onRemove($event)
                }
              }
            },
            [
              _c("EditorCloseIcon", {
                attrs: { "primary-color": "#000", size: "xsmall" }
              })
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-6a943997";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Select/Tag.vue.js